<div
  class="slide-viewer"
  (mouseenter)="mouseOut()"
  (mouseleave)="addSceneIndex = undefined"
>
  <div class="slide-header flex-row gap-6">
    <div class="line"></div>
    <div class="flex-row gap-2" style="height: 24px">
      <div style="width: 20px">
        <nw-icon
          type="fast_rewind"
          [size]="fastRewindHover ? 16 : 13"
          (mouseenter)="fastRewindHover = true"
          (mouseleave)="fastRewindHover = false"
          (click)="goToPrevFrame()"
        ></nw-icon>
      </div>
      <div style="width: 20px">
        <nw-icon
          type="play_arrow"
          [size]="playArrowHover ? 20 : 16"
          (mouseenter)="playArrowHover = true"
          (mouseleave)="playArrowHover = false"
          (click)="playFrames()"
        ></nw-icon>
      </div>
      <div style="width: 20px">
        <nw-icon
          type="fast_forward"
          [size]="fastForwardHover ? 16 : 13"
          (mouseenter)="fastForwardHover = true"
          (mouseleave)="fastForwardHover = false"
          (click)="goToNextFrame()"
        ></nw-icon>
      </div>
    </div>
    <div class="line"></div>
  </div>

  <div style="position: relative; display: table; margin-left: 16px">
    <div
      *ngIf="currentTime$ | async"
      class="time-pin"
      [style.left.px]="(currentTime$ | async) - 7"
    ></div>
    <div class="slides-container flex-row">
      <!-- <div class="slide" (click)="goToFirstScene()" [class.active]="isActive()">
        <img [src]="rootThumbnail" style="width: 100%; height: 100%" alt="" />
      </div> -->

      <!-- <ng-container *ngFor="let scene of scenes$ | async; let i = index"> -->
      <!-- <ng-container *ngFor="let frame of frames; let i = index">
        <div
          class="slide"
          [class.active]="isActive(frame)"
          (click)="goToFrame(frame)"
          [ngClass]="{
            'add-after': i === addSceneIndex,
            'add-before': i === addSceneIndex + 1,
          }"
          (mouseenter)="mouseOver(i); $event.stopPropagation()"
        >
          <div
            class="icon-container"
            (click)="$event.stopPropagation(); deleteScene(frame)"
          >
            <nw-icon type="close" [size]="11"></nw-icon>
          </div>

          <img
            [src]="getThumbnailDataUrl(frame.id)"
            style="width: 100%; height: 100%; object-fit: contain"
            [style.visibility]="
              !imgError[frame.id] && imgLoaded[frame.id] ? 'visible' : 'hidden'
            "
            alt=""
            (load)="imgLoaded[frame.id] = true; imgError[frame.id] = false"
            (error)="imgError[frame.id] = true; imgLoaded[frame.id] = false"
          />
        </div>
        <div
          class="add-after-button flex-column space-around pointer"
          (click)="addNewScene(frame)"
          [style.width.px]="addSceneIndex == i ? 28 : 12"
          (mouseenter)="addIconSize = 15"
          (mouseleave)="addIconSize = 12"
        >
          <nw-icon
            type="add"
            *ngIf="addSceneIndex == i"
            [size]="addIconSize"
            [color]="'white'"
          >
          </nw-icon>
        </div>
      </ng-container> -->

      <nw-slide-item
        *ngFor="let item of scenes$ | async; let i = index"
        [index]="i"
        [slide]="item"
      ></nw-slide-item>

      <nw-slide-item [newSceneMode]="true"></nw-slide-item>

      <!-- <div
        class="slide last flex-row space-around"
        (click)="addNewScene()"
        (mouseenter)="addLastIconSize = 15"
        (mouseleave)="addLastIconSize = 12"
      >
        <nw-icon type="add" [size]="addLastIconSize" [color]="'white'">
        </nw-icon>
      </div> -->
    </div>
  </div>
</div>
